export const TEST_IDS = {
  nav: {
    logo: "nav-logo",
    home: "nav-home",
    about: "nav-about",
    strategies: "nav-strategies",
    portfolio: "nav-portfolio",
    insights: "nav-insights",
    contact: "nav-contact",
    portal: "nav-portal",
    login: "nav-login",
    logout: "nav-logout",
    mobileToggle: "nav-mobile-toggle",
  },
  home: {
    heroCta: "hero-cta-button",
    heroSecondary: "hero-secondary-button",
    statAum: "stat-aum",
    statProjects: "stat-projects",
    statGeo: "stat-geo",
    sectorCard: "sector-card",
    globalMap: "global-map",
    insightCard: "insight-card",
  },
  ai: {
    launcher: "ai-launcher",
    dialog: "ai-dialog",
    agentSelect: "ai-agent-select",
    input: "ai-input",
    send: "ai-send",
    voiceToggle: "ai-voice-toggle",
    close: "ai-close",
  },
  contact: {
    name: "contact-name",
    email: "contact-email",
    org: "contact-org",
    interest: "contact-interest",
    message: "contact-message",
    submit: "contact-submit",
  },
  auth: {
    google: "auth-google",
    logout: "auth-logout",
  },
  dash: {
    tabDeals: "dash-tab-deals",
    tabProjects: "dash-tab-projects",
    tabNotes: "dash-tab-notes",
    tabAnalytics: "dash-tab-analytics",
    windowSelect: "dash-window-select",
    newDeal: "dash-new-deal",
    newProject: "dash-new-project",
    newNote: "dash-new-note",
    exportPdf: "dash-export-pdf",
    exportPptx: "dash-export-pptx",
    seedDemo: "dash-seed-demo",
    dealRow: "dash-deal-row",
    projectRow: "dash-project-row",
  },
};
